// src/pages/settings/securitySettings.js
import React from "react";
import { Button } from "antd";
import SettingsRow from "./components/settingsRow";

const SecuritySettings = ({ onClearCacheClick }) => (
  <div className="stg-sub-page">
    <SettingsRow label="Maintenance">
      <Button danger onClick={onClearCacheClick}>
        Clear Site Cache
      </Button>
    </SettingsRow>
  </div>
);

export default SecuritySettings;
